<div class="container">
  <mat-tab-group [selectedIndex]="selected.value" (selectedTabChange)="selected.setValue($event.index)">
    <mat-tab label="Histórico Traslados de Inventario">
      <div  class="mt-4">
        <data-table
          [titleExcelFile]="'histórico_traslados_inventario'"
          [columns]='columnsTableIT'
          [configuration]='configTable'
          [reloadTable]='reloadTablaIT'
          [params]="params"
          [url]='urlTableIT'
          (add)='newItem($event)'
          (view)='viewItem($event)'
          [headerFileXlsm]="headerFileXlsm"
        ></data-table>
      </div>
    </mat-tab>

    @if (selected.value == 1 || selected.value == 2) {
      <mat-tab label="Detalle">
        <div style="width: 100%">
          <app-button-label [labelsEdit]="labels">
          </app-button-label>
          <data-table
            [titleExcelFile]="'detalle_traslado_inventario_' + labels[0].value"
            [columns]="columnsDetails"
            [data]="dataDetails"
            [configuration]="configurationDetails"
            [reloadTable]="reloadTablaDetails"
            [headerFileXlsm]="headerDetailsFileXlsm"
            >
          </data-table>
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</div>
